import { render, staticRenderFns } from "./talentManage.vue?vue&type=template&id=5bf70b35&scoped=true"
import script from "./talentManage.vue?vue&type=script&lang=js"
export * from "./talentManage.vue?vue&type=script&lang=js"
import style0 from "./talentManage.vue?vue&type=style&index=0&id=5bf70b35&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf70b35",
  null
  
)

export default component.exports